import { signal } from '@angular/core';

export interface StatusManager {
  error: ReturnType<typeof signal<unknown>>;
  loading: ReturnType<typeof signal<boolean>>;
  setError: (newError: unknown) => void;
  resetError: () => void;
  setLoading: (value: boolean) => void;
  reset: () => void;
}

export function useStatusManager(): StatusManager {
  const error = signal<unknown>(null);
  const loading = signal<boolean>(false);

  function setError(newError: unknown) {
    error.set(newError);
  }

  function resetError() {
    error.set(null);
  }

  function setLoading(value: boolean) {
    loading.set(value);
  }

  function reset() {
    error.set(null);
    loading.set(false);
  }

  return {
    error,
    loading,
    setError,
    resetError,
    setLoading,
    reset,
  };
}
